import { EntityList } from '@lib/entity';
import { FileDocumentEntity } from './file-document-entity';

import type { Entity } from './file-document-entity';

class FileDocumentEntityList extends EntityList<FileDocumentEntity> {
    constructor(items: Entity[] | null, count?: number | null) {
        super(FileDocumentEntity, items, count);
    }
}

export { FileDocumentEntityList };
